import React, { PureComponent } from 'react';
import moment from 'moment';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { Col, Row } from 'elements';

import * as ROUTES from 'config/routes';
import GridCards from './components/grid-cards';
import ZoneFilter from './components/zone-filter';
import FilterBar from './components/filter-bar'
import { holdersSelector } from 'redux/selectors'
import {
	listSites,
	listZones,
	listenToSubscriptions,
	listenToFaceSubscriptions,
} from 'redux/modules/model/site';
import { logUserTab } from 'redux/modules/user/index'
import { liveViewEnabledRedir } from 'hocs/auth';
import { PageContainer } from 'smart-components';
import { PageContent } from 'components';
import { parseQueryString, jsonToQueryString } from 'utils/helpers';
import {
	liveDiscoverySelector,
	liveFaceDiscoverySelector,
} from 'redux/selectors';
import { listHolders } from 'redux/modules/model/holder'
import { userIsAuthenticatedRedir } from 'hocs/auth';
import { withClientId } from 'hocs';
import { ZONE_ENTITIES_VALIDATE_INTERVAL } from 'config/constants';
import * as actions from '@/redux/new_store_structure/actions';
import { wsClient } from '@/index';

class FaceLiveView extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			queryParams: {
				view: 'large',
				...parseQueryString(this.props.location.search),
			},
			siteId: null,
			zoneId: null,
			allSitesList: [],
			showZoneItems: false,
		};
	}

	componentDidMount() {
		const { getSitesList, clientId, listHolders, logUserTab } = this.props;
		getSitesList({ clientId });
		const activeFilter = { active: true }
		listHolders({ clientId, filter: activeFilter })
		this.timerId = window.setInterval(
			this.props.clearInactiveEntities,
			ZONE_ENTITIES_VALIDATE_INTERVAL,
		);
		const tab = "Live View"
		logUserTab({ clientId, tab })
	}
	componentDidUpdate(prevProps, prevState) {
		const { siteId, zoneId } = this.state;
		const { sitesList, clientId, getZonesList, zonesList, faceAlertsList } = this.props;
        console.log("🚀 ~ file: index.js ~ line 66 ~ FaceLiveView ~ componentDidUpdate ~ faceAlertsList", faceAlertsList)
        console.log("🚀 ~ file: index.js ~ line 66 ~ FaceLiveView ~ componentDidUpdate ~ this.props", this.props)

		this.setState({allSitesList: faceAlertsList})
		if (siteId === "null"){
			prevProps.faceAlertsList.forEach(record => {
				faceAlertsList.forEach((newRecord,i) => {
					if(record.clientReference === newRecord.clientReference){
						if(record.detectionTime > newRecord.detectionTime){
							var item = {detectionTime: record.detectionTime,
								clientReference: record.clientReference,
								siteId: record.siteId,
								zoneId: record.zoneId}
								faceAlertsList[i] = item
							this.setState({allSitesList: faceAlertsList})
						}
					}
				})
			})
			this.state.allSitesList.forEach(record => {
				faceAlertsList.forEach((newRecord,i) => {
					if(record.clientReference === newRecord.clientReference){
						if(record.detectionTime > newRecord.detectionTime){
							var item = {detectionTime: record.detectionTime,
										clientReference: record.clientReference,
										siteId: record.siteId,
										zoneId: record.zoneId}
										faceAlertsList[i] = item
							this.setState({allSitesList: faceAlertsList})
						}
					}
				})
			})
		}
		if (siteId && prevState.siteId !== siteId) {
			getZonesList({ clientId, siteId });
			this.subscribe();
			this.setShowZoneItems();
		}
		if (sitesList && sitesList.length > 0 && !siteId) {
			this.handleSiteChange(sitesList[0].siteId);
		}
		if (zonesList && zonesList.length > 0 && !zoneId && siteId) {
			const newZone =
				zonesList && zonesList.length === 1
					? zonesList[0].zoneId
					: 'null';
			this.handleZoneChange(newZone);
		}
	}

	componentWillUnmount() {
		this.timerId && window.clearInterval(this.timerId);
		this.unsubscribe();
	}

	setShowZoneItems = () => this.setState({ showZoneItems: true });

	setURLHref(params) {
		const { history } = this.props;
		history.push({
			location: ROUTES.LIVE_VIEW_DIRECTORY,
			search: jsonToQueryString(params),
		});
	}

	handleFilterChange = value => {
		const { filters, grouping, view, search } = this.state.queryParams;
		let newFilters = filters;

		const key = Object.keys(value)[0];
		const position = filters.indexOf(key);
		if (value[key] && position === -1) {
			newFilters.push(key);
		}

		if (!value[key] && position !== -1) {
			newFilters = [
				...filters.slice(0, position),
				...filters.slice(position + 1),
			];
		}

		this.setURLHref({
			filters: newFilters,
			grouping,
			view,
			search,
		});
	};

	handleViewModeChange = view => {
		this.setURLHref({
			...this.state.queryParams,
			view,
		});
	};

	handleSearch = search => {
		this.setURLHref({
			...this.state.queryParams,
			search: encodeURIComponent(search),
		});
	};

	handleSearchChange = e => {
		this.setState({
			search: e.target.value,
		});
		const params = {
			...parseQueryString(location.search),
			search: e.target.value,
		};
		this.setURLHref(params);
	};

	handleSiteChange = siteId => {
		const newQueryStr = {
			...this.state.queryParams,
			site: encodeURIComponent(siteId),
			zone: 'null',
			search: this.state.search
		};
		this.setURLHref(newQueryStr);
		this.setState({ queryParams: newQueryStr, siteId });
	};

	handleZoneChange = zoneId => {
		const newQueryStr = {
			...this.state.queryParams,
			zone: encodeURIComponent(zoneId),
			search: this.state.search
		};
		this.setURLHref(newQueryStr);
		this.setState({ queryParams: newQueryStr, zoneId });
	};

	handleFaceChange = val => {
		const newQueryStr = {
			...this.state.queryParams,
			face: encodeURIComponent(val),
		};
		this.setURLHref(newQueryStr);
		this.setState({ queryParams: newQueryStr, face: val });
	};

	subscribe = () => {
		const { siteId } = this.state;
        console.log("🚀 ~ file: index.js ~ line 215 ~ FaceLiveView ~ siteId", siteId)
		const {
			listenToFaceSubscriptions,
			clientId,
			verticalConfig,
			sitesList
		} = this.props;
		console.log("🚀 ~ file: index.js ~ line 185 ~ FaceLiveView ~ sitesList", sitesList)
		const enabledVerticals = Object.keys(verticalConfig);
		if (enabledVerticals.includes('face')) {
			listenToFaceSubscriptions({
				clientId,
				siteId,
				includeLastKnown: true,
			});
		}
		// if (siteId === 'null') {
		// 	sitesList.forEach(site => {
		// 		const currentSite = site.siteId
        //         console.log("🚀 ~ file: index.js ~ line 192 ~ FaceLiveView ~ currentSite", currentSite)
		// 		if (enabledVerticals.includes('face')) {
		// 			listenToFaceSubscriptions({
		// 				clientId,
		// 				siteId: currentSite,
		// 				includeLastKnown: true,
		// 			});
		// 		}
		// 	})
		// } else {
		// 	console.log(siteId)
		// 	if (enabledVerticals.includes('face')) {
		// 		listenToFaceSubscriptions({
		// 			clientId,
		// 			siteId,
		// 			includeLastKnown: true,
		// 		});
		// 	}
		// }
		
	};
	unsubscribe = () => {
		wsClient.clearAllCorrelations('thermal.face.subscribe-face-events');
	};

	render() {
		const {
			queryParams: { zone: zoneId, site: siteId },
		} = this.state;
        console.log("🚀 ~ file: index.js ~ line 292 ~ LiveView ~ render ~ this.state", this.state)
		const params = parseQueryString(location.search)
		let search = params.search

		const {
			faceAlertsList,
			zonesList: zones,
			sitesList: sites,
			holdersList
		} = this.props;
            console.log("🚀 ~ file: index.js ~ line 307 ~ LiveView ~ render ~ faceAlertsList", faceAlertsList)
        // console.log("🚀 ~ file: index.js ~ line 307 ~ LiveView ~ render ~ this.props", this.props)
		let clientReferencesList = []
		holdersList.forEach((holder, i) => {
			if (holder.name.toUpperCase().includes((search || "").toUpperCase()) || !search) {
				clientReferencesList.push(holder.clientReference)
			}
		})
		console.log("🚀 ~ file: index.js ~ line 310 ~ LiveView ~ render ~ clientReferencesList", clientReferencesList)

		const faceMap = faceAlertsList.reduce((res, val) => {
			res[val.clientReference] = val;
			return res;
		}, {});
        console.log("🚀 ~ file: index.js ~ line 333 ~ LiveView ~ faceMap ~ faceMap", faceMap)

		let newFaceList = []
		faceAlertsList.forEach((faceDetection, i) => {
			console.log(faceDetection)
			newFaceList.push({
				clientReference: faceDetection.clientReference,
				detectionTime: faceDetection.detectedAt,
				siteId: faceDetection.zone.siteId,
				zoneId: faceDetection.zone.zoneId
			})
		})
		console.log("🚀 ~ file: index.js ~ line 339 ~ LiveView ~ faceAlertsList.forEach ~ newFaceList", newFaceList)
		// newFaceList = newFaceList.sort(
		// 	(item1, item2) =>
		// 		moment(item2.detectionTime).unix() -
		// 		moment(item1.detectionTime).unix(),
		// )
		let filteredBySite = newFaceList
		if (siteId !== "null")
			filteredBySite = newFaceList.filter(
				el => el.siteId === siteId,
			);
		console.log(zoneId)
		const zoneItems =
		zoneId && zoneId !== 'null'
			? filteredBySite
				.filter(item => {
					return item.zoneId ? item.zoneId === zoneId : false;
				})
				// Sort by reverse chronological order
				.sort(
					(item1, item2) =>
						moment(item2.detectionTime).unix() -
						moment(item1.detectionTime).unix(),
				)
			: filteredBySite.sort(
				(item1, item2) =>
					moment(item2.detectionTime).unix() -
					moment(item1.detectionTime).unix(),
			);
		return (
			<PageContainer>
				<PageContent className={'no-btm-padding'}>
					<PageContent.Main>
						<div className="live-view">
							<Row gutter={16}>
								<Col md={12}>
									<ZoneFilter
										onZoneChange={this.handleSiteChange}
										zoneId={siteId}
										zones={sites}
										placeholder="Select a site"
										idKey="siteId"
										nameKey="description"
										optAll={{
											label: 'All sites',
											value: 'null',
										}}
									/>

									<ZoneFilter
										onZoneChange={this.handleZoneChange}
										zoneId={zoneId}
										zones={zones}
										placeholder="Select a zone"
										idKey="zoneId"
										nameKey="name"
										optAll={{
											label: 'All zones',
											value: 'null',
										}}
										disabled={siteId === undefined}
									/>
								</Col>
								<Col md={12}>
									<FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
								</Col>
							</Row>
							<GridCards list={zoneItems} siteId={siteId} />
						</div>
					</PageContent.Main>
				</PageContent>
			</PageContainer>
		);
	}
}

export const selector = createStructuredSelector({
	faceAlertsList: liveFaceDiscoverySelector,
	sitesList: ({ sites }) => sites.list,
	zonesList: ({ sites }) => sites.zonesList,
	verticalConfig: ({ user: { currentUser } }) => currentUser.verticalConfig,
	holdersList: holdersSelector
});

export const mapDispatchToProps = dispatch => ({
	listSites: params => dispatch(listSites(params)),
	listZones: params => dispatch(listZones(params)),
	listenToSubscriptions: params => dispatch(listenToSubscriptions(params)),
	listenToFaceSubscriptions: params =>
		dispatch(listenToFaceSubscriptions(params)),
	getSitesList: params => dispatch(actions.getSitesList(params)),
	getZonesList: params => dispatch(actions.getSitesZonesList(params)),
	logUserTab: params => dispatch(logUserTab(params)),
	listHolders: params => dispatch(listHolders(params))
});

export default compose(
	userIsAuthenticatedRedir,
	liveViewEnabledRedir,
	withRouter,
	withClientId,
	connect(selector, mapDispatchToProps),
)(FaceLiveView);



// WEBPACK FOOTER //
// ./src/pages/face-live-view/index.js